/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { type Flag, toFlagId } from '@atlassian/jira-flags/src/services/types';

import { defineMessage } from '@atlassian/jira-intl';

const boardNotFound = defineMessage({
	id: 'query-string-notifier.common.board-not-found',
	defaultMessage: 'Board not found',
	description: '',
});

const boardNotFoundDescription = defineMessage({
	id: 'query-string-notifier.common.board-not-found-description',
	defaultMessage:
		"You tried to access a board that doesn't exist or that you don't have permission to see.",
	description: '',
});

const projectNotFound = defineMessage({
	id: 'query-string-notifier.common.project-not-found',
	defaultMessage: 'Project not found',
	description: '',
});

const projectNotFoundDescription = defineMessage({
	id: 'query-string-notifier.common.project-not-found-description',
	defaultMessage:
		"You tried to access a project that doesn't exist or that you don't have permission to see.",
	description: '',
});

const projectNotFoundDescriptionGalaxia = defineMessage({
	id: 'query-string-notifier.common.project-not-found-description-galaxia',
	defaultMessage:
		"You tried to access a space that doesn't exist or that you don't have permission to see.",
	description: '',
});

const projectNotFoundGalaxia = defineMessage({
	id: 'query-string-notifier.common.project-not-found-galaxia',
	defaultMessage: 'Space not found.',
	description: '',
});

/**
 * Maps query-string IDs to `Flag`s
 */
type NotificationMessages = {
	[notificationId: string]: Flag;
};

export const notificationMessagesWithProjectTerm: NotificationMessages = {
	'jsw.board-not-found': {
		id: toFlagId('jsw.board-not-found'),
		type: 'error',
		title: boardNotFound,
		description: boardNotFoundDescription,
		// eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
		messageId: 'query-string-notifier.common.flag.error.error.jsw.board-not-found',
		messageType: 'transactional',
	},
	'jsw.project-not-found': {
		id: toFlagId('jsw.project-not-found'),
		type: 'error',
		title: projectNotFound,
		description: projectNotFoundDescription,
		// eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
		messageId: 'query-string-notifier.common.flag.error.error.jsw.project-not-found',
		messageType: 'transactional',
	},
};

export const notificationMessagesWithoutProjectTerm: NotificationMessages = {
	'jsw.board-not-found': {
		id: toFlagId('jsw.board-not-found'),
		type: 'error',
		title: boardNotFound,
		description: boardNotFoundDescription,
		// eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
		messageId: 'query-string-notifier.common.flag.error.error.jsw.board-not-found.1',
		messageType: 'transactional',
	},
	'jsw.project-not-found': {
		id: toFlagId('jsw.project-not-found'),
		type: 'error',
		title: projectNotFoundGalaxia,
		description: projectNotFoundDescriptionGalaxia,
		// eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
		messageId: 'query-string-notifier.common.flag.error.error.jsw.project-not-found.1',
		messageType: 'transactional',
	},
};
